import classNames from 'classnames';
import { FC } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { FormattedMessage } from 'react-intl';
import contentItemCss from '#srcCssModules/advert/list-filter/advert-list-filter-content-item.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';

const Close: FC = () => {
  const { hide } = useFilterContext();

  const handlerClick = () => {
    hide();
  };

  return (
    <Button
      variant={ButtonVariant.unstyled}
      additionalClassName={classNames(
        contentItemCss.advertListFilterContentItem,
        contentItemCss.advertListFilterContentItem_active,
        contentItemCss.advertListFilterContentItem_uppercase,
      )}
      onClick={handlerClick}
    >
      <FormattedMessage defaultMessage="Close" />
    </Button>
  );
};

export { Close };
